var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-link');
import { breakpoints } from '@shapeable/theme';
import { entityTypeNamePluralSlug } from '../../utils/entity-type-plural-slug';
import { trim } from 'lodash';
import { useLink } from '../../hooks/use-link';
export var EntityLinkDefaultProps = {
  basePath: '/'
}; // -------- Child Component Props -------->
// -------- Styles -------->

var BodyStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Body: styled.span.attrs(cls.attr('body'))(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var EntityLink = function EntityLink(props) {
  var className = props.className,
      entity = props.entity,
      children = props.children,
      basePath = props.basePath;
  var Link = useLink().Link;
  var entityPath = props.entityPath || entityTypeNamePluralSlug(entity);
  var href = entity.url || entity.path || trim(basePath, '/') + "/" + trim(entityPath, '/') + "/" + entity.slug;

  var style = __assign(__assign({}, props.style || {}), {
    textDecoration: 'none'
  });

  return React.createElement(Link, {
    style: style,
    href: href
  }, React.createElement(My.Body, {
    className: cls.name(className)
  }, children || entity.name));
};
EntityLink.defaultProps = EntityLinkDefaultProps;
EntityLink.cls = cls;
var templateObject_1, templateObject_2;